import React from 'react'
import { isPresented } from '../../Helpers/FundUtility.js'

export default function FundDisclosureMain({ fund }) {
  const disclosureSections = [
    'miscTop',
    'performance',
    'expenseRatio',
    'morningstar',
    'morningstarStyleBox',
    'indexInformation',
    'definitions',
    'miscBottom',
  ]
  let fundGroup = getFundGroup()
  const fundDisclosures = fund.disclosures.filter(
    (docType) => docType[fundGroup]
  )

  function getFundGroup() {
    return fund.fundName === 'Tri-Continental Corporation'
      ? 'closed-end-2'
      : fund.fundGroup.replace(/ /g, '-').toLowerCase()
  }

  function sortArray(arr1, arr2) {
    arr2.sort((a, b) => {
      const aKey = a[Object.keys(a)[0]]
      const bKey = b[Object.keys(b)[0]]

      return arr1.indexOf(aKey) - arr1.indexOf(bKey)
    })
  }

  function parseArray(arr1, arr2) {
    arr1.forEach((sectionLabel) => {
      arr2.forEach((section) => {
        if (sectionLabel.toLowerCase() === section.type) {
          section.type = sectionLabel
        }
      })
    })

    sortArray(arr1, arr2)
  }

  if (fundDisclosures && fundDisclosures.length > 0) {
    parseArray(disclosureSections, fundDisclosures[0][fundGroup])
  }

  return (
    <div
      id={`${fund.fundGroup.replace(/ /g, '-').toLowerCase()}-disclosure`}
      className="Content"
    >
      {fundDisclosures &&
        fundDisclosures.length > 0 &&
        fundDisclosures[0][fundGroup] &&
        fundDisclosures[0][fundGroup].map((sectionLabel) => {
          if (
            sectionLabel.type === 'morningstarStyleBox' &&
            !isPresented(fund, 'morningStarEquityStyleBox') &&
            fundGroup.includes('closed-end')
          ) {
            return null
          }
          return (
            <div
              key={sectionLabel.type}
              id={
                sectionLabel.type === 'definitions'
                  ? 'definitions'
                  : `${sectionLabel.type}-disclosures`
              }
              className="u-marginBottom4gu"
              dangerouslySetInnerHTML={{ __html: sectionLabel.content }}
            />
          )
        })}
    </div>
  )
}
